// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./HelveticaNow-300.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./HelveticaNow-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./HelveticaNow-500.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./HelveticaNow-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./HelveticaNowDisplay-300.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./HelveticaNowDisplay-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./HelveticaNowDisplayOTF-300.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./HelveticaNowDisplayOTF-700.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./HelveticaNowOTF-300.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./HelveticaNowOTF-400.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./HelveticaNowOTF-500.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./HelveticaNowOTF-700.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'HelveticaNow300normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNow400normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNow500normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNow700normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowDisplay300normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowDisplay700normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowDisplayOTF300normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowDisplayOTF700normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowOTF300normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowOTF400normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowOTF500normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-display: block;
}
@font-face {
  font-family: 'HelveticaNowOTF700normal';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-display: block;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@telus-uds/palette-allium/build/rn/fonts/fonts.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,4CAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,4CAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,4CAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,4CAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,4CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,4CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,8CAA8C;EAC9C,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,8CAA8C;EAC9C,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,4CAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,4CAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,6CAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,6CAAqC;EACrC,mBAAmB;AACrB","sourcesContent":["@font-face {\n  font-family: 'HelveticaNow300normal';\n  src: url('./HelveticaNow-300.woff');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNow400normal';\n  src: url('./HelveticaNow-400.woff');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNow500normal';\n  src: url('./HelveticaNow-500.woff');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNow700normal';\n  src: url('./HelveticaNow-700.woff');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowDisplay300normal';\n  src: url('./HelveticaNowDisplay-300.woff');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowDisplay700normal';\n  src: url('./HelveticaNowDisplay-700.woff');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowDisplayOTF300normal';\n  src: url('./HelveticaNowDisplayOTF-300.otf');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowDisplayOTF700normal';\n  src: url('./HelveticaNowDisplayOTF-700.otf');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowOTF300normal';\n  src: url('./HelveticaNowOTF-300.otf');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowOTF400normal';\n  src: url('./HelveticaNowOTF-400.otf');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowOTF500normal';\n  src: url('./HelveticaNowOTF-500.otf');\n  font-display: block;\n}\n@font-face {\n  font-family: 'HelveticaNowOTF700normal';\n  src: url('./HelveticaNowOTF-700.otf');\n  font-display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
